import waterExtractionS2 from "../../assets/images/models/water_extraction_s2.jpg";

const models = [
  {
    id: "water_extraction_s2",
    type: "Water Body Extraction (Sentinel-2)",
    image: waterExtractionS2,
    available: { start: "2015-06-27", end: null },
    description:
      "The water extraction network is a Transformer network based on the attention mechanism and is an encoder-decoder structure. The encoder is established based on the Swin Transformer, which is a hierarchical vison Transformer. And the decoder includes a Pyramid Pooling Module (PPM) and a Feature Pyramid Network (FPN). The network can obtain different attention of water body in the image and extract water body features at multiple levels from global to local. Thus, it can capture the overall connection and difference between water body and other ground objects to extract water bodies accurately. ",
    chips: {
      developer: "Song",
      element: "Water Body",
      resolution: "10 meters",
      dataSource: "Sentinel-2",
    },
    action: {
      type: "internal",
      route: "/computing/model/hkh_water_predict",
      color: "info",
      label: "Select",
    },
  },
];

export default models;
